module.exports = __webpack_public_path__ + "img/cylinder _chart.392b554d.svg";